const getContrastColor = (hex: string) => {
  let hexValue = hex.replace('#', '')
  if (hexValue.length === 3) {
    hexValue = hexValue.split('').map((c) => c + c).join('')
  }
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(hexValue.slice(i, i + 2), 16))
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? 'black' : 'white'
}

export { getContrastColor }
